// API base URL
export const API_BASE_URL = 'https://imgapi.sudhanvapaturkar.com';

// API endpoints
export const API_ENDPOINTS = {
  getImageById: '/getImageById',
  updateOriginal: '/updateOriginal',
  operation: '/operation',
  saveImage: '/saveImage',
  getImageHistogram: '/getImageHistogram'
};
